import { trackEventTemplateThumbnailClick } from "utils/gAnalyticsUtils";

import useUsers from "./useUsers";

const useTemplateGroupTracking = (templateGroup) => {
  const { currentUser } = useUsers();

  const trackClick = () => {
    trackEventTemplateThumbnailClick(templateGroup, currentUser);
  };

  return {
    trackClick,
  };
};

export default useTemplateGroupTracking;
